import styled from 'styled-components';
import { colorCSS, minWidth, maxWidth } from '../../styles';
export const Form = styled.form `
  display: flex;
  gap: 1rem;
  justify-content: center;

  @media ${maxWidth.md} {
    /* BxpButton wrapper */
    > div {
      flex-grow: 1;

      button {
        justify-content: center;
        width: 100%;
      }
    }
  }

  .xs-text-left & {
    justify-content: start;
  }
  .xs-text-center & {
    justify-content: center;
  }

  @media ${minWidth.sm} {
    .sm-text-left & {
      justify-content: start;
    }
    .sm-text-center & {
      justify-content: center;
    }
  }
  @media ${minWidth.md} {
    flex-wrap: wrap;

    .md-text-left & {
      justify-content: start;
    }
    .md-text-center & {
      justify-content: center;
    }
  }
  @media ${minWidth.lg} {
    .lg-text-left & {
      justify-content: start;
    }
    .lg-text-center & {
      justify-content: center;
    }
  }
  @media ${minWidth.xl} {
    .xl-text-left & {
      justify-content: start;
    }
    .xl-text-center & {
      justify-content: center;
    }
  }
`;
export const InputEmail = styled.input `
  display: none;

  ${({ bxpProminence }) => bxpProminence}
  border: 1px solid ${colorCSS('N40')};
  border-radius: 0.3rem;
  max-width: 376px;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  transition: 250ms ease-out;
  width: 376px;

  ::placeholder {
    color: ${colorCSS('N80')};
    opacity: 1;
  }

  @media ${minWidth.md} {
    display: block;
  }
`;
//# sourceMappingURL=UiEmailSignup.styles.js.map